// Utils
import { getKeys, propIn, length } from '../../../common/utils/immutableHelper';

export const getSuggestionsMap = propIn(['temp', 'suggestions']);
export const getSuggestionsKeys = (element) => {
    let suggestions = getSuggestionsMap(element);
    suggestions = suggestions && suggestions.filter((entry) => entry);

    return getKeys(suggestions);
};

export const alreadySuggestingAnything = (element) => length(getSuggestionsKeys(element)) >= 1;
export const alreadySuggested = (element, feature) => !!propIn(['temp', 'suggestions', feature], element);
